import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import ArchivePage from "@/pages/ArchivePage.vue";
import PictureArchive from '@/pages/PictureArchive.vue';
import ViewPage from "@/pages/ViewPage.vue";
import RootPage from "@/pages/RootPage.vue";
import LoginPage from "@/pages/LoginPage.vue";
import LogoutPage from "@/pages/LogoutPage.vue";

const routes = [
  {
    path: "/",
    component: RootPage,
    redirect: "login",
    children: [
      {
        name: "Login",
        path: "login",
        component: LoginPage,
        meta: {
          requiresAuth: false
         }
      }
    ]
  }, {
    path: "*",
    component: LoginPage,
  }, {
    path: "/dashboard",
    redirect: "/p/view/0",
    component: DashboardLayout,
    children: [
      {
        path: "/p/archive",
        name: "Archive",
        component: ArchivePage,
        meta: {
          requiresAuth: true
         }
      }, {
        path: "/p/photoarchive",
        name: "Photoarchive",
        component: PictureArchive,
        meta: {
          requiresAuth: true
        }
      }, {
        path: "/p/logout",
        component: LogoutPage,
        name: "Logout",
        meta: {
          requiresAuth: true
        }
      }, {
        path: "/p/view/:id",
        name: "View",
        props: true,
        component: ViewPage,
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
];

export default routes;
